import Chartist from 'chartist'
import ctAxisTitle from 'chartist-plugin-axistitle'
import { CurrencyContext } from 'contexts'
import PropTypes from 'prop-types'
import React from 'react'
import {
  Card,
  Col,
  Row,
  ToggleButton,
  ToggleButtonGroup,
} from 'react-bootstrap'
import ChartistGraph from 'react-chartist'
import { injectIntl } from 'react-intl'

function ProgressChart(props) {
  const currency = React.useContext(CurrencyContext)
  const data = {
    series: props.series,
  }

  const options = {
    lineSmooth: false,
    fullWidth: true,
    showPoint: false,
    axisX: {
      type: Chartist.AutoScaleAxis,
      onlyInteger: true,
      showGrid: false,
    },
    axisY: {
      onlyInteger: true,
      labelInterpolationFnc: function (value) {
        return props.intl
          .formatNumber(value, {
            style: 'currency',
            currency: currency.code,
          })
          .replace(/\D00$/, '')
      },
    },
    chartPadding: {
      left: 55,
      right: 40,
    },
    plugins: [
      ctAxisTitle({
        axisY: {
          axisTitle: 'Amount',
          flipTitle: true,
          offset: {
            x: 0,
            y: 20,
          },
        },
      }),
    ],
  }

  return (
    <Card className="progress-chart shadow">
      <Card.Body>
        <Card.Title>PROGRESS</Card.Title>
        <ChartistGraph
          className="ct-minor-seventh"
          type="Line"
          data={data}
          options={options}
        />
        <Row className="my-3">
          <Col sm={8} md={6} className="mx-auto text-center">
            <ToggleButtonGroup
              size="sm"
              name="axis-x"
              defaultValue={props.xAxis}
              onChange={props.onToggleXAxis}
            >
              <ToggleButton value="sessions">SESSIONS</ToggleButton>
              <ToggleButton value="hours">HOURS</ToggleButton>
            </ToggleButtonGroup>
          </Col>
        </Row>
        <div className="small text-center text-muted legend d-flex justify-content-center">
          <div className="key">
            EV <div className="series ev"></div>
          </div>
          <div className="key">
            Earnings <div className="series earnings"></div>
          </div>
        </div>
      </Card.Body>
    </Card>
  )
}

ProgressChart.propTypes = {
  series: PropTypes.arrayOf(PropTypes.array).isRequired,
  xAxis: PropTypes.oneOf(['sessions', 'hours']),
  onToggleXAxis: PropTypes.func.isRequired,
}

ProgressChart.defaultProps = {
  xAxis: 'sessions',
  onToggleXAxis: () => {},
}

export default injectIntl(ProgressChart)
